import type { CreditTopUpDetails, CreditTopUpDetailsResponse, TopUpOption } from '../types';

// A server released before `top_up_options` existed only sends the price of these three packs. Remove this fallback
// (and the legacy response fields) once every environment serves `top_up_options`.
const legacyTopUpOptions = (data: CreditTopUpDetailsResponse): TopUpOption[] => [
  { credits: 25, amount: data.top_up_25_credits },
  { credits: 50, amount: data.top_up_50_credits },
  { credits: 200, amount: data.top_up_200_credits },
];

export const creditTopUpDetailsMapper = (data: CreditTopUpDetailsResponse | null): CreditTopUpDetails | null => {
  if (!data) return null;

  return {
    topUpOptions: data.top_up_options ?? legacyTopUpOptions(data),
    cardId: data.card_id ?? null,
    cardBrand: data.card_brand ?? null,
    cardLast4: data.card_last_4 ?? null,
    cardExpMonth: data.card_exp_month ?? null,
    cardExpYear: data.card_exp_year ?? null,
  };
};
